document.addEventListener("DOMContentLoaded", function () {
    let isLazyPaginationLoading = false;
    const productsContainer = document.querySelector('.lazy-load-product-list');
    const loadingIndicator = document.getElementById('loading-indicator');
    const nextPageLink = document.getElementById('next-page');
    const paginationInfo = document.getElementById('pagination-info');
    let lastPaginationLink = '';

    window.addEventListener('scroll', () => {
        const seoTextElement = document.querySelector('.reading-width-seo-text');
        const distanceToEnd = seoTextElement
            ? (seoTextElement.getBoundingClientRect().top - window.innerHeight) < 500
            : (document.body.offsetHeight - window.innerHeight - window.scrollY) < 1500;

        if (distanceToEnd && !isLazyPaginationLoading && nextPageLink && lastPaginationLink != nextPageLink.href) {
            lastPaginationLink = nextPageLink.href
            paginationLazyLoadMoreProducts(nextPageLink.href);
        }
    });

    function paginationLazyLoadMoreProducts(url) {
        isLazyPaginationLoading = true;
        loadingIndicator.style.display = 'block';

        fetch(url)
            .then(response => response.text())
            .then(data => {
                const parser = new DOMParser();
                const newDocument = parser.parseFromString(data, 'text/html');

                const newProducts = newDocument.querySelectorAll('.lazy-load-product-list .product-block');
                const newNextPageLink = newDocument.getElementById('next-page');
                const newPaginationInfo = newDocument.getElementById('pagination-info');

                newProducts.forEach(product => productsContainer.appendChild(product));

                if (newNextPageLink) {
                    nextPageLink.href = newNextPageLink.href;
                } else {
                    nextPageLink.remove();
                }

                if (newPaginationInfo.getAttribute('data-has-next-page') === 'false') {
                    if (nextPageLink) {
                        nextPageLink.remove();
                    }
                }

                loadingIndicator.style.display = 'none';
                isLazyPaginationLoading = false;
            })
            .catch(error => {
                console.error('Error loading more products:', error);
                loadingIndicator.style.display = 'none';
                isLazyPaginationLoading = false;
            });
    }
});